import { fromJS, Map as ImmMap } from 'immutable';
import ProductFilters from 'models/ProductFilters';

import {
	FETCH_ERROR,
	IS_FETCHING,
	RESET_FILTERS,
	RECEIVE_FILTERABLE_OPTIONS,
	RECEIVE_FILTERS,
	RECEIVE_SPEC_ATTRIBUTES,
	SET_MAX_PRICE_TEXT,
	SET_MIN_PRICE_TEXT,
} from './constants';

export const initialState = new ImmMap({
	fetchError: undefined,
	filterableOptions: new ImmMap(),
	filters: new ProductFilters(),
	isFetching: false,
	attributes: new ImmMap(), // Specification Attributes available in eSTORIS for product filtering.
	attributeOptions: new ImmMap(),
	maxPriceText: '',
	minPriceText: '',
});

const ProductFilterReducer = (state = initialState, action) => {
	switch (action.type) {
		case FETCH_ERROR:
			return state.set('fetchError', action.fetchError);
		case IS_FETCHING:
			return state.set('isFetching', action.isFetching);
		case RECEIVE_FILTERS: {
			const currentFilters = Object.assign(new ProductFilters(), state.get('filters'));
			const newFilters = Object.assign(currentFilters, action.filters);
			return state.set('filters', newFilters);
		}
		case RESET_FILTERS: {
			const cleanFilters = new ProductFilters();
			return state.merge({ maxPriceText: '', minPriceText: '', filters: cleanFilters });
		}
		case RECEIVE_FILTERABLE_OPTIONS: {
			return state.setIn(['filterableOptions', action.catId], action.options);
		}
		case RECEIVE_SPEC_ATTRIBUTES: {
			// 08/10/17 - drop any dimension related filters.
			// eSTORIS returns every spec attribute in the database but we will need to figure out a better way
			// to let the user filter based on dimensions
			const dimensions = ['WIDTH', 'HEIGHT', 'DEPTH', 'WEIGHT'];
			const attributesObj = {};
			const optionsObj = {};
			action.specAttributes.attributes.forEach(attribute => {
				if (!dimensions.includes(attribute.name.toUpperCase())) {
					attributesObj[attribute.id] = {
						name: attribute.name,
						displayOrder: attribute.displayOrder,
						optionIds: [],
					};
					attribute.options.forEach(option => {
						optionsObj[option.id] = {
							name: option.name,
							displayOrder: option.displayOrder,
							colorRGB: option.colorRGB,
							attributeId: attribute.id,
						};

						attributesObj[attribute.id].optionIds.push(option.id);
					});
				}
			});
			return state
				.set('attributes', fromJS(attributesObj))
				.set('attributeOptions', fromJS(optionsObj));
		}
		case SET_MAX_PRICE_TEXT:
			return state.set('maxPriceText', action.maxPriceText);
		case SET_MIN_PRICE_TEXT:
			return state.set('minPriceText', action.minPriceText);
		default:
			return state;
	}
};

export default ProductFilterReducer;
